// src/components/Auth/LoginCarousel.js
import React, { useState } from "react";
import { Carousel, CarouselItem, CarouselIndicators } from "reactstrap";
import riboSeqImg from "../../assets/images/eirna/login/carousal2.png";
import translatomicsImg from "../../assets/images/eirna/login/carousal1.png";
import dataVisualizationImg from "../../assets/images/eirna/login/carousal2.png";
// import riboSeqImg from "../../assets/images/eirna/login/gemini1.png";

const items = [
  {
    src: riboSeqImg,
    altText: "Carousel Image 1",
    title: "Harnessing the Power of Translatomics",
    description:
      "",
  },
  {
    src: translatomicsImg,
    altText: "Carousel Image 2",
    title: "Advanced Analysis Tools",
    description:
      "",
  },
  {
    src: dataVisualizationImg,
    altText: "Carousel Image 3",
    title: "Secure & Scalable Infrastructure",
    description:
      "",
  },
];

const LoginCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item, index) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={index}
        style={{
          // height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "auto",
          padding: "20px",
          boxSizing: "border-box",
          position: "relative",
        }}
      >
        <img
          src={item.src}
          alt={item.altText}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />

        {/* Centered Overlay Text */}
        <div
          style={{
            position: "absolute",
            top: "50%", // Changed from "60px" to "50%"
            left: "50%", // Added for horizontal centering
            transform: "translate(-50%, -50%)", // Center both horizontally and vertically
            textAlign: "center",
            padding: "0 40px",
            zIndex: "5",
            width: "90%", // Ensure text doesn't overflow
            maxWidth: "800px", // Maximum width for better readability
          }}
        >
          <h2
            style={{
              color: "#fff",
              fontSize: "32px",
              fontWeight: "700",
              marginBottom: "16px",
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              lineHeight: "1.2",
            }}
          >
            {item.title}
          </h2>
          <p
            style={{
              color: "rgba(255, 255, 255, 0.95)",
              fontSize: "18px",
              lineHeight: "1.5",
              margin: "0",
              textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
            }}
          >
            {item.description}
          </p>
        </div>
      </CarouselItem>
    );
  });

  return (
    <div
      style={{
        // height: "100vh",
        width: "100%",
        position: "relative",
        backgroundColor: "white",
      }}
    >
      <Carousel
        activeIndex={activeIndex}
        next={next}
        previous={previous}
        interval={4000}
        ride="carousel"
        style={{
          width: "100%",
          overflow: "hidden",
        }}
        controls={false}
        indicators={true}
      >
        {slides}

        <CarouselIndicators
          items={items}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
          style={{
            position: "absolute",
            bottom: "30px",
            left: "50%",
            transform: "translateX(-50%)",
            margin: "0",
            zIndex: "10",
          }}
        />
      </Carousel>
    </div>
  );
};

export default LoginCarousel;
